import Dam from "../Dam/Dam";
import { DamsContainer, TableHeader } from "./DamsStyles";

function Dams(props) {
  const {
    dams,
    updateSelectedVolantes,
    dateRucHook,
    onChangeVolantesForInvoice,
    loadDateWithdrawal,
    dni,
    refreshBilling,
  } = props;
  return (
    <DamsContainer>
      <TableHeader>
        <div className="main-info-header">DAM/CONSIGNATARIO</div>
        <div>TIPO DE RETIRO</div>
        <div>ESTADO DAM</div>
        <div>FECHA LEVANTE</div>
        <div>VOLANTES FACTURADOS</div>
      </TableHeader>
      <div>
        {dams.map((dam) => (
          <Dam
            dni={dni}
            loadDateWithdrawal={loadDateWithdrawal}
            key={dam.id}
            dateRucHook={dateRucHook}
            updateSelectedVolantes={updateSelectedVolantes}
            onChangeVolantesForInvoice={onChangeVolantesForInvoice}
            dam={dam}
            refreshBilling={refreshBilling}
          />
        ))}
      </div>
    </DamsContainer>
  );
}

export default Dams;
